import React from 'react';

import EventsIndex from '../../components/events/EventsIndex';
import PageLayout from '../../components/layout/PageLayout';

const EventsPage = () => {
  return (
    <PageLayout>
      <EventsIndex />
    </PageLayout>
  );
};

export default EventsPage;
